/**
 * Stand-in for the Mondu legal-entity search, which is still being defined. It only feeds
 * suggestions — a name it does not have can still be typed and added — so replacing this module with
 * the real source does not change what is addable.
 */

export interface QuoteEntity {
  id: string;
  name: string;
  /** Street, city and state on one line, as the frame renders it. */
  addressLine: string;
}

export const QUOTE_ENTITY_CATALOG: QuoteEntity[] = [
  { id: 'entity-tandem-logistics', name: 'Tandem Logistics LLC', addressLine: '411 Harrow Ave, Omaha, NE' },
  { id: 'entity-tarpley-foods', name: 'Tarpley Foods Inc', addressLine: '82 Canal Street, Buffalo, NY' },
  { id: 'entity-thornwood-mfg', name: 'Thornwood Manufacturing Co', addressLine: '1700 Foundry Rd, Akron, OH' },
  { id: 'entity-brightline-retail', name: 'Brightline Retail Group', addressLine: '95 Market Square, Austin, TX' },
  { id: 'entity-cedarpoint-supply', name: 'Cedar Point Supply Corp', addressLine: '240 Lakeview Dr, Sandusky, OH' },
  { id: 'entity-northgate-paper', name: 'Northgate Paper & Packaging', addressLine: '6 Mill Pond Way, Portland, ME' },
  { id: 'entity-orchard-valley', name: 'Orchard Valley Distributors', addressLine: '1215 Vineyard Ln, Fresno, CA' },
  { id: 'entity-summit-ridge', name: 'Summit Ridge Industrial', addressLine: '3300 Quarry Blvd, Denver, CO' },
];

/** Case-insensitive substring match on the name. The real search will rank and page. */
export const findQuoteEntities = (query: string): QuoteEntity[] => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return [];

  return QUOTE_ENTITY_CATALOG.filter((entity) => entity.name.toLowerCase().includes(normalized));
};
